// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <wt-horizontal-categorical-chart class=\"fill\" component-id=\"openTicketByStatus\" data=\"vm.data\" options=\"vm.options\" series=\"vm.series\"></wt-horizontal-categorical-chart> </div>";
// Exports
module.exports = code;